import React, { useContext } from 'react'

import { context } from '..'

export const withTheme = Component => props => {
    const theme = useContext(context)
    return <Component {...props} theme={theme} />
}

export default withTheme